<template>
    <div class="request-messages">
        <b-button v-if="!expanded" variant="info" v-b-modal="'messages_'+_uid" size="sm" title="cronologia">
            <font-awesome-icon icon="clipboard-list" />
        </b-button>
        <b-modal :id="'messages_'+_uid" :title="title" size="xl" hide-footer
            @show="() => {
                get_history_from_api()
            }">
            <b-spinner v-if="loading"></b-spinner>
            <div class="request-messages--modal" v-if="!loading">

                <b-form-checkbox
                    id="includi_logs_sistema"
                    name="includi_logs_sistema"
                    v-model="includi_logs_sistema"
                    @change="() => { this.get_history_from_api() }"
                >
                  Includi logs sistema
                </b-form-checkbox>

                <table v-if="messages.length > 0">
                    <thead>
                        <tr>
                            <td>
                                data
                            </td>
                            <td>
                                chi
                            </td>
                            <td>
                                evento
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="request-messages--message" v-for="(message,index) in messages" v-bind:key="index">
                            <td>
                                <div class="request-messages--date">
                                  {{message.created_at | moment("DD-MM-YYYY HH:mm") }}
                                </div>
                            </td>
                            <td>
                              <div class="request-messages--from">
                                <i><span v-html="message.banconista_display_name"></span></i>
                              </div>
                            </td>
                            <td>

                                <div class="request-messages--body" v-html="message.log"></div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <span v-else>nessun evento in cronologia</span>
            </div>
        </b-modal>

        <div v-if="expanded">
            <div class="request-messages-preview--heading">
                <label>
                    <span>Ultimi eventi</span>
                    <font-awesome-icon icon="pencil-alt" v-b-modal="'messages_'+_uid" />
                </label>
                <!--<font-awesome-icon icon="pencil-alt" v-b-modal="'messages_'+_uid" />-->
                <small v-if="messages.length == 0"><i>Non ci sono ancora note interne per questa proposta</i></small>
            </div>
            <div v-if="messages.length > 0">
                <table v-if="messages.length > 0" class="request-messages-preview--table">
                    <tbody>
                        <tr class="request-messages--message" v-for="(message,index) in messages.slice(0, 5)" v-bind:key="index">
                            <td>
                                <div class="request-messages--from">
                                    <i><span v-html="message.banconista_display_name"></span></i>
                                </div>
                            </td>
                            <td>
                                <div class="request-messages--date">
                                  {{message.created_at | moment("DD-MM-YYYY HH:mm") }}
                                </div>
                            </td>
                            <td>
                                <div class="request-messages--body" v-html="message.log"></div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import { get_history } from '@/api/'

    export default {
        name: 'history',
        components: {
        },
        props: {
            request_id:{
                type: String,
                default: '',
            },
            soldquotes_id:{
                type: String,
                default: '',
            },
            expanded: {
                type: Boolean,
                default: false,
            }
        },
        created() {
        },
        data() {
            return {
                banconiste: Vue.prototype.$config.banconiste,
                messages: [],
                loading: true,
                new_message_public: '',
                new_message_private: '',
                includi_logs_sistema: false,
            }
        },
        mounted() {
            if (this.expanded) this.get_history_from_api()
        },
        methods:
        {
            get_history_from_api(){
                this.loading = true

                // api discrimina quale endpoint chiamare in base a quale è valorizzato
                get_history({
                    request_id: this.request_id,
                    soldquotes_id: this.soldquotes_id,
                    includi_logs_sistema: (this.includi_logs_sistema)? 1 : 0,
                })

                .then((response)=>{
                    // la risposta è paginata ma lato be teniamo un alto numero di records per pagina
                    // quindi ci dovrebbe bastare gestire solo la prima pagina
                    this.messages = response.result.data
                    this.loading = false
                })
            },

        },
        computed: {
          title: {
            get(){
              return (this.request_id != '')? 'Eventi R-' + this.request_id : 'Eventi P-' + this.soldquotes_id
            },
            set(){},
          },
        }
    }
</script>

<style lang="scss">
    // spostato in _messages.scss
</style>